<template>
    <div class="page-not-found">
        <div class="not-found">
            <div class="grid-container">
                <div class="box">
                    <img class="image" :src="require('@/Assets/Images/facilita.png')" alt="Facilita App" />
                    <h1 class="title">Não foi possível carregar as informações da página.</h1>

                    <p class="caption">
                        <a class="link" @click="redirectToExternalUrl('https://www.appfacilita.com/')">www.appfacilita.com</a>
                    </p>
                </div>
            </div>
        </div>

        <the-footer />
    </div>
</template>

<script>
    import TheFooter from '@/Components/TheFooter'

    export default {
        components: {
            TheFooter,
        },

        methods: {
            redirectToExternalUrl(url) {
                window.location.href = url
            },
        },

        mounted() {
            this.$nextTick(() => {
                document.title = 'Facilita Corretor'
            })
        },
    }
</script>

<style lang="stylus">
    @import 'style'
</style>
